export default __webpack_public_path__ + "static/media/Bolo-De-Cafe.7abd2b79.jpg";